import React from "react";
import { extent } from "d3";
import { scaleLinear, scaleOrdinal } from "@visx/scale";
import { AreaStack } from "@visx/shape";
import { motion } from "framer-motion";
import { LegendOrdinal } from "@visx/legend";
import { AxisBottom, AxisLeft } from "@visx/axis";
import { format } from "d3";
import "./Area.css";

const AreaChart = ({
  data,
  width,
  height,
  margin = { top: 20, bottom: 30, left: 40, right: 20 },
}) => {
  // set dimensions
  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;

  // create accessor functions
  const x = (d) => d.year;
  const y0 = (d) => d[0];
  const y1 = (d) => d[1];

  const keys = Object.keys(data[0]).filter(
    (key) => key !== "is02c" && key !== "country" && key !== "year"
  );

  // create scales
  const xScale = scaleLinear({
    range: [margin.left, innerWidth + margin.left],
    domain: extent(data, x),
  });

  const yScale = scaleLinear({
    range: [innerHeight + margin.top, margin.top],
  });

  const colorScale = scaleOrdinal({
    domain: keys,
    range: ["#045A8D", "#2B8CBE", "#74A9CF", "#BDC9E1", "#F1EEF6"],
  });

  // return chart
  return (
    <div>
      <LegendOrdinal
        scale={colorScale}
        direction="row"
        labelMargin="0 20px 0 0"
        style={{
          display: "none",
          justifyContent: "space-between",
        }}
      />
      <svg width={width} height={height}>
        <AreaStack
          top={margin.top}
          left={margin.left}
          data={data}
          keys={keys}
          x={(d) => xScale(x(d.data))}
          y0={(d) => yScale(y0(d))}
          y1={(d) => yScale(y1(d))}
        >
          {({ stacks, path }) =>
            stacks.map((stack) => (
              <motion.path
                initial={false}
                animate={{ d: path(stack) }}
                key={`stack-${stack.key}`}
                stroke="black"
                strokeWidth={0.5}
                fill={colorScale(stack.key)}
              />
            ))
          }
        </AreaStack>
        <AxisBottom
          scale={xScale}
          top={innerHeight + margin.top}
          tickFormat={format("d")}
        />
        <AxisLeft
          scale={yScale}
          left={margin.left}
          tickFormat={format(".0%")}
        />
      </svg>
    </div>
  );
};

export default AreaChart;
